
class Transformer {

  constructor (enter, exit, opts) {
    let data = enter.datum()

    this.duration = opts.duration

    /*
     * Set a two part flag if we're rotating from a globe that's rotated
     */
    this.twoPart = !!(opts.container.classed('globe') && // currently a globe and...
      ((data.projection && data.projection.rotate().some(Boolean)) ||  // The projection is rotated
      (exit.size() && exit.datum().projection.rotate().some(Boolean)))) // The old projection was rotated
  }

  getDuration () {
    return this.duration
  }

  /*
   * Returns a feature collection to use for `fitSize`. By default uses
   * the incoming `geojson`. If `nodes` are defined to an array of tree nodes,
   * a new feature collection is created with just those tree nodes. This is
   * used for multi feature zooming.
   */
  _buildFeatureCollection (nodes, geojson) {
    if (!nodes || nodes.length === 0) {
      return geojson
    }

    let ids = nodes.map(node => node.key)

    return {
      type: 'FeatureCollection',
      features: geojson.features.filter(feature => !!ids.find(id => id == feature.id))
    }
  }

  /*
   * Called at the end of the transition. Transformers can override
   */
  end () {

  }

}

export default Transformer
